import { gql, TypedDocumentNode } from 'apollo-angular';

import {
  IWithdrawExternalPropertyInput,
  IWithdrawExternalPropertyResult,
} from '@shared/models/my-deals';

import { EXTERNAL_PROPERTY_USER_LISTING_FRAGMENT } from '@graphql/queries/my-deals.queries';
import { MUTATION_ERROR_FRAGMENT } from '@graphql/errors.fragments';

export const WITHDRAW_EXTERNAL_PROPERTY: TypedDocumentNode<
  IWithdrawExternalPropertyResult,
  IWithdrawExternalPropertyInput
> = gql`
  ${EXTERNAL_PROPERTY_USER_LISTING_FRAGMENT}
  ${MUTATION_ERROR_FRAGMENT}
  mutation withdrawExternalProperty($id: ID!, $isLoggedIn: Boolean! = true) {
    withdrawExternalProperty(id: $id) {
      errors {
        ...ErrorFragment
      }
      result {
        ...ExternalPropertyUserListingFragment
      }
    }
  }
`;
